'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIntl = require('react-intl');

var _baseBcReactComponent = require('@bibliocommons/base-bc-react-component');

var _baseBcReactComponent2 = _interopRequireDefault(_baseBcReactComponent);

var _baseInlineOverlay = require('@bibliocommons/base-inline-overlay');

var _baseButtons = require('@bibliocommons/base-buttons');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var DuplicateSavedSearch = function (_BcReactComponent) {
  _inherits(DuplicateSavedSearch, _BcReactComponent);

  function DuplicateSavedSearch(props) {
    _classCallCheck(this, DuplicateSavedSearch);

    var _this = _possibleConstructorReturn(this, (DuplicateSavedSearch.__proto__ || Object.getPrototypeOf(DuplicateSavedSearch)).call(this, props));

    _this.bindAll('handleReplace');
    return _this;
  }

  _createClass(DuplicateSavedSearch, [{
    key: 'handleReplace',
    value: function handleReplace() {
      var query = window.location.search;
      this.props.replaceSearch(query);
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        { className: 'cp-duplicate-saved-search' },
        _react2.default.createElement(
          'div',
          { className: 'form-group' },
          _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'save_search_duplicate_prompt', values: { search_name: this.props.lastNameAttempt } })
        ),
        _react2.default.createElement(
          _baseInlineOverlay.InlineOverlayFooter,
          null,
          _react2.default.createElement(
            _baseButtons.PrimaryButton,
            {
              handleClick: this.handleReplace,
              id: 'save_search_save',
              isLoading: this.props.isSaving },
            _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'save_search_replace' })
          ),
          _react2.default.createElement(
            _baseButtons.DefaultButton,
            { handleClick: this.props.chooseNewName, 'data-test-id': 'save-search-new-name' },
            _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'save_search_new_name' })
          ),
          _react2.default.createElement(
            _baseInlineOverlay.InlineOverlayCloseButton,
            { className: 'btn btn-default' },
            _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'button_cancel' })
          )
        )
      );
    }
  }]);

  return DuplicateSavedSearch;
}(_baseBcReactComponent2.default);

DuplicateSavedSearch.propTypes = {
  isSaving: _react.PropTypes.bool,
  replaceSearch: _react.PropTypes.func.isRequired,
  lastNameAttempt: _react.PropTypes.string.isRequired,
  chooseNewName: _react.PropTypes.func.isRequired
};

exports.default = DuplicateSavedSearch;


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/saved-search/lib/components/duplicate-saved-search/components/DuplicateSavedSearch.component.js
// module id = 1464
// module chunks = 1